import { IntlProvider, load } from '@progress/kendo-react-intl';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import caGregorian from 'cldr-dates-full/main/uk/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/uk/dateFields.json';
import localCurrency from 'cldr-numbers-full/main/uk/currencies.json';
import numbers from 'cldr-numbers-full/main/uk/numbers.json';

load(
  likelySubtags,
  currencyData,
  dateFields,
  caGregorian,
  localCurrency,
  numbers,
  weekData,
);

const KendoLocaleProvider = ({ children }) => {
  return <IntlProvider locale='uk-UA'>{children}</IntlProvider>;
};

export default KendoLocaleProvider;
